import { UrlSegment } from '@angular/router';

import { RpcRoute } from '@core-layout/app/models/rpc-route';
import { restoreSlashedUrlCode } from './utils/restore-slashed-url-code';

export const mortgageReportMatcher = (url: UrlSegment[]) => {
    const [pageSegment, ...segments] = url;

    if (pageSegment?.path === RpcRoute.MortgageReport) {
        return { consumed: [pageSegment], posParams: { code: restoreSlashedUrlCode(segments) } };
    }

    return null;
};